module.exports = __webpack_public_path__ + "img/q1_2018.e1c41b08.png";